<template>
    <b-card no-body class="card-challenges-picture">
      <b-button :to="link">
        <div class="header" :style="{'background-image': `url(${theMedia})`}">
          <div class="loadImg" :class="{hidden:hide}" :style="{'background-color': '#E1E5E8'}">
            <div class="img-logo">
              <img src="/img/logo-areas-B&W.png" height="100px" width="100px">
            </div>
          </div>

          <div class="top-left">
            <p class="subtitle">
              <PuSkeleton :loading="isLoading" :count="1" width="80px">  
                {{subtitle}}
              </PuSkeleton>
            </p>
            <p class="title">
              <PuSkeleton :loading="isLoading" :count="1" height="40px"  width="120px">                                            
                {{title}}
              </PuSkeleton>
            </p>
          </div>

          <div class="bottom-right target"  :class='getTargetClass()'>
              {{target == 'done' ? 'Terminé' : target == 'todo' ? 'A venir' : 'En cours'}}
          </div>
        </div>

        <!-- FOOTER -->
        <div class="footer">


          <!-- LEFT -->
          <div class="left">

            <div class="head">
              {{ranking}}
            </div>

            <div class="numbers">
              <PuSkeleton :loading="isLoading" :count="1" height="30px" width="60%">                                            
                  <div class="target mr-2" :class="[isPositif = diffBool(rankingPrevious,rank) ? 'negatif' : 'positif']">{{diffBool(rankingPrevious,rank) ? '-' : diff(rankingPrevious,rank) == 0 ? '=' : '+' }} {{diff(rankingPrevious,rank) == 0 ? '' : diff(rankingPrevious,rank)}}</div>
                  <div class="big">{{rank}}</div>
                  <div class="small"> / {{rankingNumber}}</div>
              </PuSkeleton>
            </div>

          </div>
          <!-- LEFT -->


          <!-- RIGHT -->
          <div class="right">

            <div class="head">
            {{score}}
            </div>

            <div class="big">
              <PuSkeleton :loading="isLoading" :count="1" height="30px" width="100px">
                {{Math.round(scoreNumber).toLocaleString()}}
              </PuSkeleton>
            </div>

          </div>
          <!-- RIGHT -->

        </div>
        <!-- FOOTER -->

      </b-button>
    </b-card>
</template>


<script>
import ApiService from '../../../services/ApiService'
import Utils from '../../Utils'
//
export default {
  name: "CardChallengesPicture",

  props:{
    subtitle:{
      default:'Jeu concours'
    },
    title:{
      // default:'Pura Vidas'
    },
    targetTitle:{
      default:''
    },
    ranking:{
      default:'Classement'
    },
    rankingNumber:{
      default:"83"
    },
    rank:{
      default:"1"
    },    
    rankingPrevious:{
      default:"10"
    },    
    score:{
      default:'score'
    },
    scoreNumber:{
      default:"250001"
    },
    target:{
      default:'+1'
    },
    img:{
      // type:String
    },
    isLoad:{
      type:Boolean,
      default: true
    },
    link:{
      default:'#'
    },
  },
  data(){
    return {
      isLoading:true,
      isImageLoading:true,
      theMedia:'',
      hide:false,
      item:{
        src:'/img/challenges-img.png'
      },      
    }
  },
  methods : {
    diff: function(start,end){
      return Utils.compare(start,end);
    },    
    diffBool: function(start,end){
      return Utils.compareBool(start,end);
    },
    getTargetClass() {
      return this.target == 'done' ? 'red' : this.target == 'todo' ? 'yellow' : 'green';
    },
    async getData (){
      if(this.img){
        this.theMedia = await ApiService.getMediaApi().get(this.img);        
        this.hide = true;
        this.isImageLoading = false;
      } else {
        this.isImageLoading = false;
      }
    },         
  },  
  mounted (){
  },
  created(){
    this.isLoading = this.isLoad;
    //
    this.getData();
  }, 
  watch : {
    'isLoad' : function (){
      this.isLoading = this.isLoad;
      this.isImageLoading = true;
      this.hide = false;
      this.getData();           
    },
  },    
}
</script>
